/* This is the way to define constances  


export const <KEY>='<VALUE>'

*/


export const PASSWORD_MAX_LEN = 50;


// WEBPACK FOOTER //
// ./src/utility/globalConstants.js